import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useUser } from '../../auth'
import AuthLayout from '../../components/auth/AuthLayout'
import NewPasswordForm from '../../components/auth/NewPasswordForm'
import { update_new_password } from '../../server/server'
import { usePageTitle } from '../../utils/util'

const NewPasswordScreen = () => {
    usePageTitle(`Upstrive Education - Set New Password`)
    const history = useHistory()
    const location = useLocation()
    const [token, setToken] = useState('')
    const [email, setEmail] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const { setUser } = useUser()

    useEffect(() => {
        // Get token and email from URL params
        const searchParams = new URLSearchParams(location.search)
        const tokenParam = searchParams.get('token')
        const emailParam = searchParams.get('email')

        if (tokenParam && emailParam) {
            setToken(tokenParam)
            setEmail(decodeURIComponent(emailParam))
        } else {
            // If missing params, redirect to login
            history.push('/login')
        }
    }, [location, history])

    const onNewPasswordSubmit = async (password) => {
        setIsLoading(true)
        setErrorMessage('')

        try {
            const resp = await update_new_password({
                email,
                password,
                token,
            })

            if (resp.status === 200) {
                const user = resp.data
                const data = resp.data

                if (data.role === 0) {
                    const token = data['token']
                    window.open(`https://student.upstrivesystem.com?token=${token}&locale=${data.locale ?? 'en'}`, '_self')
                    setErrorMessage("You will be redirected to student's page...")
                    setIsLoading(false)
                    return
                }

                setUser(user)
                localStorage.setItem('token', data['token'])
                localStorage.setItem('loginDate', Date.now())
                localStorage.setItem('user', JSON.stringify(data))
                localStorage.setItem('institution_id', data['institution_id'])

                // Navigate to dashboard after successful password reset
                history.push('/dashboard')
            } else {
                const error = resp?.data?.message || resp.data
                setErrorMessage(error)
            }
        } catch (e) {
            console.log(e)
            setErrorMessage('Error')
        }

        setIsLoading(false)
    }

    const handleBack = () => {
        history.push('/login')
    }

    return (
        <AuthLayout>
            <NewPasswordForm onSubmit={onNewPasswordSubmit} onBack={handleBack} isLoading={isLoading} errorMessage={errorMessage} />
        </AuthLayout>
    )
}

export default NewPasswordScreen
